module.exports = __webpack_public_path__ + "static/background_320-b4e13daa182442a7ebd8a95a083d4da6.png";